import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Formulario from './components/formulario';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function App() {
  return (
    <Router basename="/">
      <div className="App">
        <Routes>
          <Route path="/formulario" element={<Formulario />} />
          <Route path="/" element={<Navigate to="/formulario" replace />} />
          <Route path="*" element={<Navigate to="/formulario" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;